import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "65",
  height: "65",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { filter: "url(#filter0_d_2_2017)" }, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "32.5",
    cy: "31.5",
    r: "29.5",
    fill: "#ff4f85"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M29.808 31.787h-3.882c0-3.46.743-4.483 3.883-4.72v-3.775c-6.692 0-8.179 3.146-8.179 8.653v7.315h8.178v-7.473Zm12.227 0h-3.883c0-3.46.826-4.483 3.883-4.72v-3.775c-6.61 0-8.179 3.146-8.179 8.653v7.315h8.179v-7.473Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }